<template>
  <button
    type="button"
    :class="classes"
    v-on="$listeners"
  >
    <slot />
  </button>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';

export default {
  name: 'EPill',
  mixins: [classes],
  props: {
    /**
     * The active state
     */
    active: {
      type: Boolean,
      default: false,
      cssClass: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.pill {
  -webkit-tap-highlight-color: transparent;
  display: block;
  position: relative;
  height: $space-3l;
  min-width: $space-3l;
  padding: 0 $space-s;
  border: solid $color-border $border-width;
  border-radius: $border-radius-full;
  cursor: pointer;
  background-color: $white;
  transition: background-color $timing-2s $easing;

  &:hover {
    @include desktop {
      border-color: $color-border-hover-secondary;
    }
  }

  &:focus,
  &:active {
    outline: none;

    @include desktop {
      background-color: $gray-20;
      // special case where design specifies the same border color on hover and focus
      border-color: $color-border;
    }

    &:hover {
      border-color: $transparent;
    }
  }
}
</style>

<docs>
## DEPRECATED

```js
<div>
  <EPill>Default</EPill>
  <EPill active>Active</EPill>
</div>
```
</docs>
